import type { Item } from 'models/IItem';
import { useContext } from 'react';

import { AddonMainFormContext } from '../AddonMainForm.context';
import { ListField } from './ListField';

type OwnProps = {
  value?: number;
  availableItems?: Item<number>[];
  onChange: (newValue: string) => void;
};

export function SalesDesk({ value, availableItems, onChange }: OwnProps) {
  const { isLoading, isReadOnly } = useContext(AddonMainFormContext);
  const availableSalesDesks: readonly Item[] =
    availableItems?.map(salesDesk => ({
      value: salesDesk.value.toString(),
      label: salesDesk.label,
    })) ?? [];
  return (
    <ListField
      id="salesDesk"
      disabled={isReadOnly}
      isLoading={isLoading}
      translationKey="addon.SalesDesk"
      availableItems={availableSalesDesks}
      value={value?.toString() ?? ''}
      onValueChange={onChange}
    />
  );
}
